module.exports = __webpack_public_path__ + "img/einbauschrank-shop-layout-logo.180343ba.svg";